import React from 'react';
import {Col} from 'react-bootstrap';
import {MobileRender} from 'components';
import {CBCTable} from 'shared/components/Table/Table';
import {JobCardList} from 'components/customer/Job/JobCardList';
import {Link} from 'react-router-dom';
import {JobTableData} from 'hooks/Job/JobTable';
import {
    useIsMobileLandscape,
    useIsMobilePortrait,
    useIsTabletPortrait,
} from 'shared/helpers/DeviceSize';

type JobRender = {
    jobTableData: JobTableData[];
    isSearch: boolean;
    mdValue: number;
    useMobileCards?: boolean;
    headerAction?: React.ReactNode;
};

export const JobTableRender = ({
    jobTableData,
    isSearch = false,
    mdValue = 12,
    useMobileCards = false,
    headerAction,
}: JobRender) => {
    const isMobilePortrait = useIsMobilePortrait();
    const isMobileLandscape = useIsMobileLandscape();
    const isTabletPortrait = useIsTabletPortrait();
    const renderAsCards =
        useMobileCards &&
        (isMobilePortrait || isMobileLandscape || isTabletPortrait);

    /**
     * Render Table
     */
    return (
        <>
            {jobTableData
                .filter(
                    (option) => option.length > 0 || option.tableOption.fromApi
                )
                .map((option) => {
                    return (
                        <Col
                            key={option.title}
                            className={`jobs ${option.className}`}
                            md={mdValue}>
                            <MobileRender isVisible={option.mobileRender}>
                                {renderAsCards ? (
                                    <JobCardList
                                        title={option.title}
                                        tableOption={option.tableOption}
                                        link={option.link}
                                        headerAction={headerAction}
                                    />
                                ) : (
                                    <>
                                        {!isSearch && <h2>{option.title}</h2>}
                                        <CBCTable
                                            options={option.tableOption}
                                        />
                                        {option.link != '' && (
                                            <Link to={option.link}>
                                                See more
                                            </Link>
                                        )}
                                    </>
                                )}
                            </MobileRender>
                        </Col>
                    );
                })}
        </>
    );
};
